import {Flex, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {useDesktop} from 'hooks';
import {FC} from 'react';
import ImageUI from 'ui/ImageUI';
interface IProps {
  info: string;
}

export const ProviderInfo: FC<IProps> = ({info}) => {
  const isDesktop = useDesktop();
  return (
    <Flex alignItems="center" bg={colors.white} p={['5px', '15px']} borderRadius="16px" mb="10px">
      {isDesktop && <ImageUI src="/info-icon-black.svg" mr="10px" boxSize="30px" alt="info" />}

      <Text fontSize={['12px', '16px']} fontWeight={['600', '500']}>
        {info}
      </Text>
    </Flex>
  );
};
